import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { requestAdminLogin } from './adminAuthApi';
import { readAdminSession, saveAdminSession } from './adminSession';
import './AdminLoginPage.css';

// 로그인 실패 응답을 화면에 보여줄 문구로 바꾼다.
function toLoginErrorMessage(error) {
    const status = error.response?.status;
    if (status === 400 || status === 401) return '아이디 또는 비밀번호가 올바르지 않습니다.';
    if (status === 403) return '관리자 권한이 없는 계정입니다.';
    return '로그인하지 못했습니다. 잠시 후 다시 시도해주세요.';
}

// 관리자 로그인 화면.
export default function AdminLoginPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [values, setValues] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // 로그인 후 돌아갈 경로. 가드가 넘겨준 /admin 하위 경로만 허용한다.
    const from = location.state?.from?.pathname?.startsWith('/admin') ? location.state.from.pathname : '/admin';

    if (readAdminSession()) return <Navigate to={from} replace />;

    // 입력값을 상태에 반영하고 이전 오류를 지운다.
    const handleChange = e => {
        setValues({ ...values, [e.target.name]: e.target.value });
        setError('');
    };

    // 로그인 요청을 보내고 성공하면 세션을 저장한 뒤 이동한다.
    const handleSubmit = async e => {
        e.preventDefault();
        const username = values.username.trim();
        if (!username || !values.password) {
            setError('아이디와 비밀번호를 입력해주세요.');
            return;
        }
        setSubmitting(true);
        try {
            saveAdminSession(await requestAdminLogin(username, values.password));
            navigate(from, { replace: true });
        } catch (err) {
            setError(toLoginErrorMessage(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <main className="admin-login-page">
            <section className="admin-login-card">
                <p className="admin-login-kicker">GARAM MIND ADMIN</p>
                <h1>관리자 로그인</h1>
                <form onSubmit={handleSubmit} noValidate>
                    <label>
                        아이디
                        <input type="text" name="username" value={values.username} onChange={handleChange} autoComplete="username" autoFocus />
                    </label>
                    <label>
                        비밀번호
                        <span className="admin-login-password">
                            <input type={showPassword ? 'text' : 'password'} name="password" value={values.password} onChange={handleChange} autoComplete="current-password" />
                            <button type="button" onClick={() => setShowPassword(show => !show)} aria-label={showPassword ? '비밀번호 숨기기' : '비밀번호 보기'}>
                                {showPassword ? '숨기기' : '보기'}
                            </button>
                        </span>
                    </label>
                    {error && <p className="admin-login-error" role="alert">{error}</p>}
                    <button type="submit" className="admin-login-submit" disabled={submitting}>
                        {submitting ? '로그인 중...' : '로그인'}
                    </button>
                </form>
            </section>
        </main>
    );
}
